import { clsx } from 'clsx';

const VARIANTS = {
  primary: 'bg-gat-green text-white border-gat-green hover:bg-gat-greenLight',
  secondary: 'bg-surface text-text-dark border-border-strong hover:bg-surface-2',
  ghost: 'bg-transparent text-text-body border-transparent hover:bg-black/5',
  danger: 'bg-status-lost text-white border-status-lost hover:bg-red-700',
};

const SIZES = {
  md: 'px-3.5 py-2 text-[12px]',
  sm: 'px-2.5 py-1.5 text-[11px]',
};

export function Button({ variant = 'primary', size = 'md', disabled = false, iconLeft, className, children, ...rest }) {
  return (
    <button
      className={clsx(
        'inline-flex items-center gap-1.5 font-semibold rounded border transition-colors',
        'focus:outline-none focus:ring-2 focus:ring-gat-green/30',
        VARIANTS[variant],
        SIZES[size],
        disabled && 'opacity-45 cursor-not-allowed pointer-events-none',
        className
      )}
      disabled={disabled}
      {...rest}
    >
      {iconLeft}
      {children}
    </button>
  );
}
